import { rutaPublica } from '../../../config/recursos';
import { useTemaStore } from '../../stores/temaStore';

/**
 * Composición del logotipo.
 * `largo` es la versión horizontal, para barras y encabezados.
 * `centrado` apila el isotipo sobre el nombre, para pantallas de acceso.
 * `isotipo` es sólo el hexágono, para espacios muy reducidos.
 */
export type VarianteLogo = 'largo' | 'centrado' | 'isotipo';

interface LogoProps {
  variante?: VarianteLogo;
  /** Altura en píxeles; el ancho se ajusta solo. */
  alto?: number;
  /** Ancho en píxeles; manda sobre `alto` cuando se indica. */
  ancho?: number;
  className?: string;
  /**
   * Fuerza una versión concreta en lugar de deducirla del tema.
   * Útil sobre fondos de color, donde el tema claro seguiría pidiendo la
   * versión oscura y quedaría ilegible.
   */
  sobreFondoOscuro?: boolean;
}

/**
 * Logotipo VenIoT.
 *
 * Las imágenes son las mismas que usa la aplicación actual. La versión negra
 * se usa sobre fondos claros y la blanca sobre fondos oscuros; con el tema
 * claro u oscuro basta para acertar salvo que se indique lo contrario.
 */
export function Logo({
  variante = 'largo',
  alto = 32,
  ancho,
  className,
  sobreFondoOscuro,
}: LogoProps) {
  const tema = useTemaStore((s) => s.tema);
  const fondoOscuro = sobreFondoOscuro ?? tema === 'oscuro';

  const archivo =
    variante === 'isotipo'
      ? fondoOscuro
        ? 'logotipo-blanco.png'
        : 'logotipo-navy.png'
      : `${fondoOscuro ? 'blanco' : 'negro'}-${variante}.png`;

  return (
    <img
      src={rutaPublica(`logos/${archivo}`)}
      alt="VenIoT"
      style={
        ancho
          ? { width: ancho, height: 'auto', objectFit: 'contain' }
          : { height: alto, width: 'auto', objectFit: 'contain' }
      }
      className={className}
    />
  );
}
